import React from 'react';
import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import SegmentBar from './SegmentBar';

// Tinted panel behind a journey's cards: a colored header tab (name) + the entry
// segment as criteria chips. Positioned by the canvas; cards render on top.
export default function JourneyPanel({ journey, x, top, height, hue = 0, attributeById, onEditJourney = () => {}, innerRef }) {
  return (
    <div ref={innerRef} className={`tl-panel tl-hue-${hue}`} style={{ left: x, top, height }}>
      <div className="tl-panel-head">
        <div className="tl-panel-titles">
          <div className="tl-panel-eyebrow">Journey</div>
          <div className="tl-panel-name">{journey.name}</div>
        </div>
        <Tooltip title="Edit journey (opens placeholder)">
          <EditOutlined aria-label={`edit journey ${journey.name}`} className="tl-panel-edit" onClick={() => onEditJourney(journey.name)} />
        </Tooltip>
      </div>
      <SegmentBar segment={journey.segment} attributeById={attributeById} />
    </div>
  );
}
